/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembersWithoutSupplierData } from '../../models/members-without-supplier-data';

export interface RemoveMemberApiV2SecretariatMembersOrgIdMembershipDelete$Params {
  orgId: string;
  action: any;
  org: string;
}

export function removeMemberApiV2SecretariatMembersOrgIdMembershipDelete(http: HttpClient, rootUrl: string, params: RemoveMemberApiV2SecretariatMembersOrgIdMembershipDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithoutSupplierData>> {
  const rb = new RequestBuilder(rootUrl, removeMemberApiV2SecretariatMembersOrgIdMembershipDelete.PATH, 'delete');
  if (params) {
    rb.path('orgId', params.orgId, {});
    rb.query('action', params.action, {});
    rb.query('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembersWithoutSupplierData>;
    })
  );
}

removeMemberApiV2SecretariatMembersOrgIdMembershipDelete.PATH = '/api/v2/secretariat/members/{orgId}/membership';
